import initialState from './initialState.js'

export const resetState = (state) => {
  const s = initialState()

  Object.keys(s).forEach(key => {
    state[key] = s[key]
  })
}

export const setCategories = (state, categories) => {
  state.categories = categories
}

export const setCustomCategories = (state, categories) => {
  state.customCategories = categories
}

export const addCustomCategory = (state, categories) => {
  state.customCategories.push(categories)
}

export const updateCustomCategory = (state, categories) => {
  state.customCategories = state.customCategories.filter(item => {
    return item.id !== categories.id
  })

  state.customCategories.push(categories)
}

export const removeCustomCategory = (state, category_id) => {
  state.customCategories = state.customCategories.filter(category => {
    return category.id !== category_id
  })
}